<div class="wrp">
    <!-- @if(mediaService.deskmode()) {
    @if(menu()?.title !== 'Urlaubsziele' && menu()?.title !== 'Urlaubssuche' ) {
    <a class="w100 tbold" [href]="menu()?.link">{{menu()?.title}}</a>
    }
    } @else {
    } -->
    <!-- <div class="dropMenu">
        <a class="w100 tbold" [href]="menu()?.link">{{menu()?.title}}</a>
        @if(menu().close) {
        <img src="../../../../assets/tvg/dropdown.svg" (click)="menu().close = !menu().close" />
        } @else {
        <img src="../../../../assets/tvg/dropup.svg" (click)="menu().close = !menu().close" />
        }
    </div> -->
    @if(menu().column?.length > 0 && (!menu().close || mediaService.deskmode())) {
    <div class="columnwrp" 
    [style.gap]="mediaService.deskmode() ? '24px' : '0px'"
    [style.flex-direction]="mediaService.deskmode() ? 'row' : 'column'">
        @for (cl of menu().column; track $index) {
        <clever-menu2-subitem [column]="cl"></clever-menu2-subitem>
        }
    </div>
    }
</div>